/* Native Shopify variants, selling plans and Ajax cart. No fabricated discounts. */
(() => {
  const root = document.body.dataset.root || '/';
  const route = path => root.replace(/\/$/, '') + '/' + path;
  const qs = (s, el = document) => el.querySelector(s);
  const all = (s, el = document) => [...el.querySelectorAll(s)];
  const openers = new WeakMap();
  function openDialog(dialog, opener) {
    if (!dialog || dialog.open) return;
    openers.set(dialog, opener || document.activeElement);
    dialog.showModal(); document.documentElement.style.overflow = 'hidden';
  }
  function closeDialog(dialog) { dialog?.close(); }
  function setupDialogs(scope = document) {
    all('dialog', scope).forEach(dialog => {
      if (dialog.dataset.initialized) return;
      dialog.dataset.initialized = 'true';
      dialog.addEventListener('close', () => {
        all('video', dialog).forEach(video => video.pause());
        if (!qs('dialog[open]')) document.documentElement.style.overflow = '';
        openers.get(dialog)?.focus();
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closeDialog(dialog);
      });
    });
  }
  let cartBusy = false;
  async function jsonFetch(url, options) {
    const response = await fetch(url, { ...options, headers: { 'Content-Type': 'application/json', Accept: 'application/json', ...options?.headers } });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Unable to update your bag. Please try again.');
    return data;
  }
  async function refreshCart(sections) {
    const result = sections?.['dm-cart'] ? sections : await jsonFetch(route('?sections=dm-cart'));
    if (!result['dm-cart']) throw new Error('Your bag changed. Refresh the page to see it.');
    const doc = new DOMParser().parseFromString(result['dm-cart'], 'text/html');
    const content = qs('[data-cart-content]', doc);
    qs('[data-cart-content]')?.replaceWith(content);
    const count = Number(content.dataset.itemCount || 0);
    all('[data-cart-count]').forEach(el => el.textContent = count);
    return { item_count: count };
  }
  function showError(container, message) {
    const error = qs('.dm-form-error', container);
    if (error) { error.textContent = message; error.hidden = false; }
    else { const toast = qs('.dm-toast'); toast.textContent = message; toast.hidden = false; setTimeout(() => toast.hidden = true, 7000); }
  }
  async function changeLine(input, remove = false) {
    if (cartBusy) return;
    const content = qs('[data-cart-content]');
    const key = input.closest('[data-line-key]').dataset.lineKey;
    const quantity = remove ? 0 : Number(input.value);
    if (!Number.isInteger(quantity) || quantity < 0) return showError(content, 'Enter a whole-number quantity of zero or more.');
    cartBusy = true;
    all('input,button', content).forEach(el => el.disabled = true);
    try {
      const data = await jsonFetch(route('cart/change.js'), { method: 'POST', body: JSON.stringify({ id: key, quantity, sections: ['dm-cart'], sections_url: location.pathname }) });
      await refreshCart(data.sections);
      const current = all('[data-line-key]').find(el => el.dataset.lineKey === key);
      (qs('[data-cart-quantity]', current || content) || qs('[data-dialog-close]', qs('#dm-cart-dialog')))?.focus();
    } catch (error) {
      showError(content, error.message);
      all('input,button', content).forEach(el => el.disabled = false);
    } finally { cartBusy = false; }
  }
  document.addEventListener('click', async event => {
    const opener = event.target.closest('[data-dialog-open]');
    if (opener) openDialog(document.getElementById(opener.dataset.dialogOpen), opener);
    const close = event.target.closest('[data-dialog-close]');
    if (close) closeDialog(close.closest('dialog'));
    const cartOpen = event.target.closest('[data-cart-open]');
    if (cartOpen) { openDialog(qs('#dm-cart-dialog'), cartOpen); try { await refreshCart(); } catch (error) { showError(qs('#dm-cart-dialog'), error.message); } }
    const remove = event.target.closest('[data-cart-remove]');
    if (remove) await changeLine(remove, true);
    const carouselButton = event.target.closest('[data-carousel-next],[data-carousel-prev]');
    if (carouselButton) {
      const track = qs('[data-carousel]', carouselButton.closest('.dm-section'));
      const direction = carouselButton.hasAttribute('data-carousel-prev') ? -1 : 1;
      track?.scrollBy({ left: direction * track.clientWidth * .85, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    if (event.target.closest('.dm-menu a')) closeDialog(event.target.closest('dialog'));
  });
  document.addEventListener('change', event => { if (event.target.matches('[data-cart-quantity]')) changeLine(event.target); });
  function setupGallery(scope) {
    all('[data-gallery]', scope).forEach(gallery => {
      if (gallery.dataset.ready) return; gallery.dataset.ready = 'true';
      const slides = all('.dm-gallery-slide', gallery); let index = 0;
      all('[data-gallery-index]', gallery).forEach((button, i) => button.dataset.galleryIndex = String(i));
      function show(next) { index = (next + slides.length) % slides.length; slides.forEach((slide, i) => { slide.hidden = i !== index; if (i !== index) all('video', slide).forEach(v => v.pause()); }); all('[data-gallery-index]', gallery).forEach((button, i) => button.setAttribute('aria-pressed', String(i === index))); }
      gallery.addEventListener('click', event => { const target = event.target.closest('button'); if (!target) return; if (target.hasAttribute('data-gallery-index')) show(Number(target.dataset.galleryIndex)); if (target.hasAttribute('data-gallery-next')) show(index + 1); if (target.hasAttribute('data-gallery-prev')) show(index - 1); });
      show(0);
    });
  }
  function setupTabs(scope) {
    all('[data-tabs]', scope).forEach(widget => {
      if (widget.dataset.ready) return; widget.dataset.ready = 'true';
      const tabs = all('[role=tab]', widget);
      const activate = (tab, focus = false) => { tabs.forEach(el => { const selected = tab === el; el.setAttribute('aria-selected', String(selected)); el.tabIndex = selected ? 0 : -1; document.getElementById(el.getAttribute('aria-controls')).hidden = !selected; }); if (focus) tab.focus(); };
      tabs.forEach((tab, i) => { tab.addEventListener('click', () => activate(tab)); tab.addEventListener('keydown', event => { let n; if (event.key === 'ArrowRight') n = (i + 1) % tabs.length; if (event.key === 'ArrowLeft') n = (i + tabs.length - 1) % tabs.length; if (event.key === 'Home') n = 0; if (event.key === 'End') n = tabs.length - 1; if (n !== undefined) { event.preventDefault(); activate(tabs[n], true); } }); });
    });
  }
  function setupProducts(scope) {
    all('.dm-product-form', scope).forEach(form => {
      if (form.dataset.ready) return; form.dataset.ready = 'true';
      const product = JSON.parse(qs('[data-product-data]', form).textContent);
      const money = cents => new Intl.NumberFormat(product.locale, { style: 'currency', currency: product.currency }).format(cents / 100);
      const variantSelect = qs('[data-variant-select]', form);
      const plans = qs('[data-plan-options]', form);
      const quantity = qs('[name=quantity]', form);
      const variant = () => product.variants.find(v => String(v.id) === variantSelect.value);
      function updateTotal() {
        const v = variant(); if (!v) return;
        const planId = qs('[name=selling_plan]:checked', form)?.value;
        const plan = v.allocations.find(a => String(a.id) === planId);
        qs('[data-purchase-total]', form).textContent = money((plan?.price ?? v.price) * (Number(quantity.value) || 1));
        const terms = qs('[data-plan-terms]', form);
        terms.textContent = plan ? [plan.name, plan.description, plan.recurring ? 'Recurring purchase. The delivery schedule and terms are shown at checkout.' : 'The purchase terms are shown at checkout.'].filter(Boolean).join(' · ') : 'One-time purchase. No recurring charge.';
        qs('[type=submit]', form).disabled = !v.available || (product.requiresSellingPlan && !plan);
      }
      function updatePlans() {
        const v = variant(); plans.replaceChildren(); if (!v) return;
        const options = product.showPlans || product.requiresSellingPlan ? v.allocations : [];
        if (options.length) {
          const rows = product.requiresSellingPlan ? options : [{ id: '', name: 'One-time purchase', price: v.price }, ...options];
          rows.forEach((plan, i) => {
            const label = document.createElement('label'); label.className = 'dm-plan-option';
            const radio = document.createElement('input'); radio.type = 'radio'; radio.name = 'selling_plan'; radio.value = plan.id; radio.checked = i === 0;
            const name = document.createElement('span'); name.textContent = plan.name;
            const price = document.createElement('strong'); price.textContent = money(plan.price);
            label.append(radio, name, price); plans.append(label);
          });
        }
        updateTotal();
      }
      variantSelect.addEventListener('change', updatePlans); plans.addEventListener('change', updateTotal); quantity.addEventListener('input', updateTotal); updatePlans();
      form.addEventListener('submit', async event => {
        event.preventDefault(); if (!form.reportValidity()) return;
        const submit = qs('[type=submit]', form); if (submit.disabled) return;
        submit.disabled = true; const label = submit.textContent; submit.textContent = 'Adding…'; qs('.dm-form-error', form).hidden = true;
        const item = { id: Number(variantSelect.value), quantity: Number(quantity.value) };
        const plan = qs('[name=selling_plan]:checked', form)?.value; if (plan) item.selling_plan = Number(plan);
        try {
          const added = await jsonFetch(route('cart/add.js'), { method: 'POST', body: JSON.stringify({ items: [item], sections: ['dm-cart'], sections_url: location.pathname }) });
          closeDialog(form.closest('dialog')); await refreshCart(added.sections); openDialog(qs('#dm-cart-dialog'), openers.get(form.closest('dialog')));
        } catch (error) { showError(form, error.message); }
        finally { submit.textContent = label; updateTotal(); }
      });
    });
    all('[data-product-section]', scope).forEach(section => {
      if (section.dataset.observed) return; section.dataset.observed = 'true';
      const main = qs('.dm-main-buy', section), sticky = qs('.dm-sticky-purchase', section);
      if (main && sticky) {
        let frame = 0;
        const sync = () => { sticky.hidden = main.getBoundingClientRect().bottom > 0; frame = 0; };
        const schedule = () => { if (!frame) frame = requestAnimationFrame(sync); };
        const observer = new IntersectionObserver(sync, { threshold: 0 }); observer.observe(main);
        window.addEventListener('scroll', schedule, { passive: true });
        section.dmCleanup = () => { observer.disconnect(); window.removeEventListener('scroll', schedule); cancelAnimationFrame(frame); };
        sync();
      }
    });
  }
  function initialize(scope = document) { setupDialogs(scope); setupGallery(scope); setupTabs(scope); setupProducts(scope); }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => all('[data-product-section]', event.target).forEach(section => section.dmCleanup?.()));
  document.addEventListener('shopify:section:select', event => { if (event.target.querySelector('[data-cart-content]')) openDialog(qs('#dm-cart-dialog')); });
  document.addEventListener('shopify:block:select', event => {
    const panel = event.target.closest('[role=tabpanel]'); if (panel) document.getElementById(panel.getAttribute('aria-labelledby'))?.click();
    const gallery = event.target.closest('[data-gallery]');
    if (gallery) { const slide = event.target.closest('.dm-gallery-slide'); const i = all('.dm-gallery-slide', gallery).indexOf(slide); all('[data-gallery-index]', gallery)[i]?.click(); }
    const card = event.target.closest('.dm-content-card,.dm-ingredient'); card?.scrollIntoView({ block: 'nearest', inline: 'center' });
  });
})();
